module.exports = __webpack_public_path__ + "static/img/device.dd7117a8.png";